export const CAR_DOC_TYPE_REG_CERT = 1;
export const CAR_DOC_TYPE_PTS = 2;
export const CAR_DOC_TYPE_UTIL_CERT = 3;
export const CAR_DOC_TYPE_CONFORMITY_CERT = 4;
export const CAR_DOC_TYPE_CUSTOMS_CERT = 5;
export const CAR_DOC_TYPE_PURCHASE_CONTRACT = 6;
export const CAR_DOC_TYPE_INSPECTION_ACT = 7;
export const CAR_DOC_TYPE_PHOTOS = 8;
export const CAR_DOC_TYPE_CONSIGNMENT_CONTRACT = 9;

export const CAR_DOCUMENT_TYPE_MAP = {
  [CAR_DOC_TYPE_REG_CERT]: 'Свидетельство о регистрации ТС',
  [CAR_DOC_TYPE_PTS]: 'ПТС',
  [CAR_DOC_TYPE_UTIL_CERT]: 'Сертификат об оплате утилизационного сбора',
  [CAR_DOC_TYPE_CONFORMITY_CERT]: 'Сертификат соответствия',
  [CAR_DOC_TYPE_CUSTOMS_CERT]: 'Сертификат о прохождении таможенной очистки',
  [CAR_DOC_TYPE_PURCHASE_CONTRACT]: 'Договор выкупа',
  [CAR_DOC_TYPE_INSPECTION_ACT]: 'Акт приёмки/осмотра автомобиля',
  [CAR_DOC_TYPE_PHOTOS]: 'Фотографии автомобиля',
  [CAR_DOC_TYPE_CONSIGNMENT_CONTRACT]: 'Договор поручения',
}; 